import React, { useState, useContext, useEffect } from "react";
import Steppers from "../../../components/Steppers";
import { useTranslation } from "react-i18next";
import classes from "./Store.module.scss";
import Logo from "../../../assets/images/logo192.png"
import { useNavigate } from "react-router";
import * as r from "../../../constants/routes";
import TextField from "@mui/material/TextField";
// import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import RoundButton from '../../../components/Buttons/RoundButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from "@fortawesome/free-solid-svg-icons";
import * as api from "../../../constants/api";
import useFetch from "../../../hooks/useFetch";
import SessionContext, {
    SessionInterface
} from "../../../context/sessionContext";
import Spinner from "../../../components/Spinner";
// import { use } from "i18next";

export default function Store() {
    const history = useNavigate();
    const cSession: SessionInterface = useContext(SessionContext);
    const adminSub = cSession.admin?.sub ?? "";
    const { t } = useTranslation();

    const [pixInfo, isLoadingPix, errorPix, getPixFetch]: any = useFetch({
        autoInit: false,
    });
    const [productInfo, isLoadingProduct, errorProduct, getProductFetch]: any = useFetch({
        autoInit: false,
    });
    const [orderInfo, isLoadingOrder, errorOrder, getOrderInfo]: any = useFetch({
        autoInit: false,
    });

    const [stage, setStage] = useState<number>(1);
    const [productChoosed, setProductChoosed] = useState<number>(0);
    const [permission, setPermission] = useState<any>({
        "audiofoco_journey": 0
    });
    const [userInfo, setUserInfo] = useState<any>({
        "name": "",
        "professional_ssn": "",
        "country": "",
        "cep": "",
        "state": "",
        "city": "",
        "neighborhood": "",
        "street": "",
        "number": "",
    });
    const [qntOfJourneys, setQntOfJourneys] = useState<number>(0);
    const [termsCheckBox, setTermsCheckBox] = useState<boolean>(false);
    const [isInvoiceDataFilled, setIsInvoiceDataFilled] = useState<boolean>(false);
    const _steppers = <Steppers
        stage={stage}
        steppes={[1, 2, 3]}
        showLabels={false}
        showInsideLabel={true}
        horizontal
        checkAll
        showBottonInfo={true}
    />

    useEffect(() => {
        // se o botão voltar for clicado e voltar para o stage 1, resetar as informações
        if (stage === 1) setQntOfJourneys(0);
    }, [stage])

    useEffect(() => {
        getProductFetch({
            method: "GET",
            url: api.API_PRO_GET_PRODUCT,
            onSuccess: (data: any) => {
            },
            onError: (error: any) => {
                console.error('Erro ao obter informações do produto:', error);
            }
        })
    }, [])

    useEffect(() => {
        if (productInfo && productInfo.length > 0) setPermission(productInfo[productChoosed]?.permissions ?? { "audiofoco_journey": 0 })
    }, [productInfo, productChoosed])

    const topContent = (<>
        {_steppers}
    </>)

    const detailsCard = (
        <>
            {!isLoadingProduct ?
                <div className={classes.DetailsCard}>
                    <h2>{t("global.order_details")}</h2>
                    <div className={classes.ProductInfo}>
                        <div className={classes.ProductInfoDetails}>
                            <img src={Logo} alt="Jornada Smart" />
                            <div>
                                <div>{t("global.you_are_purchasing")}:</div>
                                <p>{t("global.smart_journey")}</p>
                            </div>
                        </div>
                        {productInfo ? <div className={classes.ProductInfoDetails}>
                            <div>
                                <p>R$: {qntOfJourneys === 0 ? 0 : qntOfJourneys === permission?.audiofoco_journey ? String(productInfo[0]?.price / 5).replace(".", ",") + "0" : String(productInfo[1]?.price / 10).replace(".", ",") + "0"}</p>
                                <div className={classes.ProductInfoDetailsByJourneyInfo}>
                                    {t("global.per_journey")}
                                </div>
                            </div>
                        </div> : <Spinner />}
                    </div>
                    <div className={classes.InfosDetailsCard}>
                        <p>{t("global.enter_quantity")}</p>
                        <p>{t("global.enter_quantity_info")}</p>
                    </div>
                    <Select
                        className={classes.InputArea}
                        autoFocus
                        required
                        defaultValue={0}
                        onChange={(e: any) => {
                            if (e.target.value < 0) {
                                e.target.value = 0;
                            }
                            setQntOfJourneys(Number(e.target.value))
                            setProductChoosed(Number(e.target.value) === 5 ? 0 : 1)
                        }}
                    >
                        <MenuItem value={0}>Escolha a quantidade</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                    </Select>
                    <div className={classes.CalculateButtonContainer}>
                        <RoundButton
                            onClick={() => setStage(stage === 3 ? 1 : stage + 1)}
                            text={t("global.continue_to_payment")}
                            title={t("global.continue_to_payment")}
                            disabled={qntOfJourneys <= 0}
                        />
                    </div>
                    <div className={classes.MoreInfo}>
                        <FontAwesomeIcon icon={fa.faCircleExclamation} />
                        {t("global.more_than_10_journeys")} {t("global.request_a_quote_with_us")}
                    </div>
                </div> : <Spinner />}</>
    )

    const reviewCard = (
        <>{!isLoadingProduct ?
            <div className={classes.ReviewCardCard}>
                <h2>{t("global.purchase_summary")}</h2>
                <div>
                    <div className={classes.InfosDetailsPrice}>
                        <div>{t("global.selected_journeys")}:</div>
                        <div>{qntOfJourneys}</div>
                    </div>
                    <div className={classes.InfosDetailsPrice}>
                        <div>{t("global.unit_price")}</div>
                        <div>R$ {qntOfJourneys === 0 ? 0 : ((productInfo[productChoosed]?.price) / qntOfJourneys)?.toFixed(2).replace(".", ",")}</div>
                    </div>
                </div>
                <div className={classes.barDivider} />
                <div className={classes.InfosDetailsPriceTotal}>
                    <div className={classes.InfosDetailsPriceTotal1}>
                        <div>{t("global.total")}:</div>
                        <div>R$ {qntOfJourneys === 0 ? 0 : qntOfJourneys === 5 ? productInfo[0]?.price?.toFixed(2).replace(".", ",") : productInfo[1]?.price?.toFixed(2).replace(".", ",")}</div>
                    </div>
                </div >
                {stage === 2 && (
                    <div className={classes.CalculateButtonContainer}>
                        <RoundButton
                            huge
                            disabled={!isInvoiceDataFilled}
                            onClick={() => setStage(3)}
                            text={t("global.continue")}
                            title={t("global.continue")} />
                    </div>
                )}
                <div className={classes.ButtonsArea}>
                    <button onClick={() => stage === 1 ? history("/") : setStage(stage - 1)}>VOLTAR</button>
                </div>
            </div> : <Spinner />}</>
    )

    const cardsAreaDetails = (
        <div className={classes.CardsArea}>
            {detailsCard}
            {reviewCard}
        </div>
    )

    const MenuItemBRStates = () => {
        const states = [
            "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
            "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
            "RS", "RO", "RR", "SC", "SP", "SE", "TO"
        ];
        const itens = states.map((state) => <MenuItem key={String(state)} value={String(state)}>{String(state)}</MenuItem>);
        return itens;
    }

    const cardPaymentInfo = (
        <div className={classes.CardInvoiceInfo}>
            <h2>{t("global.invoice_data")}</h2>
            <div className={classes.InputsArea}>
                <TextField
                    className={classes.TextField}
                    id="name"
                    autoFocus
                    required
                    label={t("global.full_name")}
                    type="text"
                    onChange={(e) => { setUserInfo({ ...userInfo, [e.target.id]: e.target.value }) }}
                />
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="professional_ssn"
                    required
                    label={t("global.cpf_cnpj")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
                <Select
                    className={classes.TextField}
                    autoFocus
                    id="country"
                    defaultValue={0}
                    required
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, "country": e.target.value })}
                >
                    <MenuItem value={0}>País</MenuItem>
                    <MenuItem value={"BR"}>Brasil</MenuItem>
                </Select>
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="cep"
                    required
                    label={t("global.cep")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
                <Select
                    className={classes.TextField}
                    autoFocus
                    id="state"
                    defaultValue={0}
                    required
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, "state": e.target.value })}
                >
                    <MenuItem value={0}>Estado</MenuItem>
                    {MenuItemBRStates()}
                </Select>
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="city"
                    required
                    label={t("global.city")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="neighborhood"
                    required
                    label={t("global.neighborhood")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="street"
                    required
                    label={t("global.street")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="number"
                    required
                    label={t("global.number")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
                <TextField
                    className={classes.TextField}
                    autoFocus
                    id="complement"
                    label={t("global.complement")}
                    type="text"
                    onChange={(e) => setUserInfo({ ...userInfo, [e.target.id]: e.target.value })}
                />
            </div>
        </div>
    )
    const invoiceCard = (
        <div className={classes.InvoiceCard}>
            {cardPaymentInfo}
            {reviewCard}
        </div>
    )

    const paymentCardInfo = (
        <div className={classes.CardPaymentInfo}>
            <RoundButton
                onClick={() => {
                    const dataToSent = {
                        professional_sub: adminSub,
                        product_id: productInfo[productChoosed]?.id_product,
                        first_name: userInfo.name,
                        name: userInfo.name,
                        last_name: userInfo.name.split(" ")[1],
                        professional_ssn: userInfo.professional_ssn.replace(/\D/g, ""),
                        email: cSession?.admin?.email ?? "",
                        address_street: userInfo.street,
                        address_number: userInfo.number,
                        address_additional_details: userInfo.complement,
                        address_zipcode: userInfo.cep.replace(/\D/g, ""),
                        address_neighborhood: userInfo.neighborhood,
                        address_city: userInfo.city,
                        address_state: userInfo.state,
                        address_country: userInfo.country,
                    }
                    getPixFetch({
                        method: "POST",
                        url: api.API_PRO_GET_PIX,
                        data: dataToSent,
                        onSuccess: (data: any) => {
                        },
                        onError: (error: any) => {
                            console.error('Erro ao criar pix:', error);
                            setStage(6);
                        }
                    })
                    setStage(4)
                }}
                text={t("purchase.pix_with_payment")}
                title={t("purchase.pix_with_payment")}
                disabled={!termsCheckBox}
            />

            <div className={classes.TermsCheckbox}>
                <input
                    type="checkbox"
                    id="creditCard"
                    name="paymentMethod"
                    value="creditCard"
                    onClick={() => setTermsCheckBox(!termsCheckBox)}
                />
                <div>{t("purchase.terms_and_privacy")}</div>
            </div>
        </div>

    )

    const paymentCard = (
        <div className={classes.PaymentCard}>
            {paymentCardInfo}
            {reviewCard}
        </div>
    )
    // exemplo de resposta do pixInfo
    // {
    //     "emv": "00020126910014BR.GOV.BCB.PIX2569api-pix-h.bancobs2.com.br/spi/v2/af4d2ed5-bb34-4b04-89e0-1dc441d943f0520400005303986540560.005802BR5905Yapay6014Belo Horizonte61083038040362070503***6304CA8B",
    //     "expiration_date": "2026-02-22T17:18:54",
    //     "orderID": 19730695,
    //     "order_id": "1:2026-02-20 20:18:50",
    //     "order_last_id": "1:2026-02-20 20:18:50",
    //     "order_status": "AP",
    //     "qrcode": "https://d3qiiqeqvrl56p.cloudfront.net/sandbox/2023/05/04/bs2/N887275971_qrcode.svg"
    // }

    const QrCode = pixInfo?.qrcode;
    const EmvCode = pixInfo?.emv;

    const pixCard = (
        <div className={classes.PixCard}>
            <h2>{t("purchase.pix_payment")}</h2>
            <div className={classes.PixInfo}>
                {isLoadingPix ? <Spinner /> : <img src={QrCode}
                    className={classes.PixInfoQrcode}
                    alt="QRCode" />}
                <div className={classes.PixQRCodeInfo}>
                    <h4>{t("purchase.how_to_pay_with_qr_code")}</h4>
                    <p>{t("purchase.pix_info_1")}</p>
                    <p>{t("purchase.pix_info_2")}</p>
                </div>
            </div>
            <p>{t("purchase.pix_payment_help")}</p>
            <div className={classes.PixInfo}>
                {isLoadingPix ? <Spinner /> : <div className={classes.PixCopyPasteArea}>
                    <h3>{EmvCode}</h3>
                    <div className={classes.PixCopyPasteAreaInfo}>
                        <div className={classes.PixCopyPasteAreaInfoIcon}>!</div>
                        <div className={classes.PixCopyPasteAreaInfoText}>
                            <div>
                                <p>{t("purchase.pix_payment_deadline")}</p>
                                <p>{t("purchase.pix_payment_cancellation")}</p>
                            </div>
                            <p>{t("purchase.pix_payment_processing")}</p>
                        </div>
                    </div>
                </div>}
                <div>
                    <div className={classes.PixQRCodeInfo}>
                        <h4>{t("purchase.how_to_pay_with_pix_copy_paste")}</h4>
                        <div>{t("purchase.copy_paste_pix_info_1")}</div>
                        <div>{t("purchase.copy_paste_pix_info_2")}</div>
                    </div>
                </div>
            </div>
        </div>
    )

    const completeOperation = (
        <div className={classes.CompleteOperation}>
            <h2>{t("purchase.complete_operation")}</h2>
            <p>{t("purchase.congratulations")}</p>
            <h3>{t("purchase.purchase_details")}</h3>
            <div className={classes.InfosDetailsOperation}>
                <div>{qntOfJourneys} {t("global.smart_journey")}</div>
                <div className={classes.InfosAndInvoiceNote}>
                    <div>Pix</div>
                </div>
            </div>
            <div>{t("purchase.invoice_sent_email")}</div>
            <div className={classes.CompleteOperationButton}>
                <RoundButton
                    onClick={() => history(r.R_A_ROOT)}
                    text={t("global.go_back_to_home")}
                    title={t("global.go_back_to_home")} />
            </div>
        </div>
    )

    const erroCreatePix = (
        <div className={classes.ErroCreatePix}>
            <h2>{t("purchase.error_creating_pix")}</h2>
            <p>{t("purchase.error_creating_pix_info")}</p>
            <div className={classes.CompleteOperationButton}>
                <RoundButton
                    onClick={() => history(r.R_A_ROOT)}
                    text={t("global.go_back_to_home")}
                    title={t("global.go_back_to_home")} />
            </div>
        </div>
    )
    let count = 0;
    useEffect(() => {
        if (stage === 4 && pixInfo?.qrcode) {
            if (adminSub && pixInfo?.orderID) {
                const interval = setInterval(() => {
                    getOrderInfo({
                        method: "GET",
                        url: api.API_PRO_GET_ORDER_INFO + "?sub=" + adminSub + "&order_id=" + pixInfo.order_id,
                        onSuccess: (data: any) => { },
                        onError: (error: any) => {
                            console.error('Erro ao obter informações do pedido:', error);
                        }
                    });
                    count += 1;
                    if (count === 100) return history("/")
                }, 20000);
                return () => clearInterval(interval);
            }
        }
    }, [stage, pixInfo?.qrcode]);

    useEffect(() => {
        if (orderInfo?.status === "PG") setStage(5);
    }, [orderInfo])

    useEffect(() => {
        const missingFields = Object.keys(userInfo).filter(key => key !== "complement" && !userInfo[key]);
        if (missingFields.length === 0) {
            setIsInvoiceDataFilled(true);
        } else {
            setIsInvoiceDataFilled(false);
        }
    }, [userInfo])

    const _holderContent: { [key: string]: JSX.Element } = {
        "1": cardsAreaDetails,
        "2": invoiceCard,
        "3": paymentCard,
        "4": pixCard,
        "5": completeOperation,
        "6": erroCreatePix,
    }


    const _content = (<>{topContent}{_holderContent[String(stage)]}</>)
    return _content
}
